"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.constructURLWithParams = exports.getEventSlugFromPath = exports.getVendorIdFromPath = exports.getOrganizationIdFromPath = exports.getSlugFromPath = exports.generateOrganizationSlug = exports.getOrgIdFromSlug = void 0;

function getOrgIdFromSlug(slug) {
  var parts = (slug || '').split('_');

  if (parts.length < 2) {
    return undefined;
  }

  return parts[parts.length - 1];
}

exports.getOrgIdFromSlug = getOrgIdFromSlug;

function generateOrganizationSlug(id, orgName) {
  var normalizedName = orgName.replace(/[^a-z0-9]+/gi, '_').replace(/^_|_$/g, '');
  return "".concat(normalizedName, "_").concat(id);
}

exports.generateOrganizationSlug = generateOrganizationSlug;
/**
 * Retrieves the event slug (being the combination of event short name + external event Id)
 */

function getSlugFromPath(pathname) {
  // extracts organization slug from the pathname URL (<org name>_<org external id>)
  // eslint-disable-next-line no-useless-escape
  var parts = (pathname || '').split('/');
  return parts[1] == 'org' ? parts[2] : undefined;
}

exports.getSlugFromPath = getSlugFromPath; // Gets the organization id from the pathname (probably window.location.pathname)

function getOrganizationIdFromPath(pathname) {
  var slug = getSlugFromPath(pathname);
  return getOrgIdFromSlug(slug);
}

exports.getOrganizationIdFromPath = getOrganizationIdFromPath; // Gets the booth id from the pathname (probably window.location.pathname)

function getVendorIdFromPath(pathname) {
  var _a;

  var ID_REGEX = /^\/vendor\/([a-zA-Z0-9]+)(?:\/.*)?$/;

  var _b = (_a = ID_REGEX.exec(pathname)) !== null && _a !== void 0 ? _a : [],
      id = _b[1];

  return id;
}

exports.getVendorIdFromPath = getVendorIdFromPath;
/**
 * Retrieves the event slug
 *
 * @param path the path to extract the slug from
 */

function getEventSlugFromPath(pathname) {
  // extracts event slug from the pathname URL
  // eslint-disable-next-line no-useless-escape
  var parts = pathname.split('/');

  if (pathname.indexOf('/org/') != -1) {
    return parts.length >= 5 && parts[3] == 'event' ? parts[4] : undefined;
  }

  if (pathname.indexOf('/organisers/events/') != -1) {
    return parts.length >= 4 ? parts[3] : undefined;
  }

  return undefined;
}

exports.getEventSlugFromPath = getEventSlugFromPath;

function constructURLWithParams(baseUrl, params) {
  if (params === void 0) {
    params = {};
  }

  var url = new URL(baseUrl);
  var searchParams = new URLSearchParams(params);
  url.search = searchParams.toString();
  return url.toString();
}

exports.constructURLWithParams = constructURLWithParams;